export default function trackClickEvent(event, params = {}) {
    window.mixpanel?.track?.(event, params);

}